import { render, staticRenderFns } from "./dividers.vue?vue&type=template&id=60358377&scoped=true&"
import script from "./dividers.vue?vue&type=script&lang=js&"
export * from "./dividers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60358377",
  null
  
)

export default component.exports